<template>

    <div>

        <personalized-game-editor-bool v-if="element.type === 'bool'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-bool>

        <personalized-game-editor-number v-if="element.type === 'number'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-number>

        <personalized-game-editor-string v-if="element.type === 'string'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-string>

        <personalized-game-editor-color v-if="element.type === 'color'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-color>

        <personalized-game-editor-choice v-if="element.type === 'choice'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-choice>

        <personalized-game-editor-list v-if="element.type === 'list'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel"></personalized-game-editor-list>

        <personalized-game-editor-image v-if="element.type === 'image'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel" :mime-types="mimeTypes"></personalized-game-editor-image>

        <personalized-game-editor-audio v-if="element.type === 'audio'" v-model="element" @input="handleInput" :location="location" :hide-label="hideLabel" :mime-types="mimeTypes"></personalized-game-editor-audio>

    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorEditorElement',

    props: {
        value: Object,
        location: String,
        hideLabel: Boolean,
        inputMimeTypes: String
    },

    data() {
        return {
            element: this.value,
            mimeTypes: null
        }
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    },

    beforeMount() {
        this.mimeTypes= this.element.mime_types ?? this.inputMimeTypes;
    }

}
</script>

<style scoped>

</style>
